<header class="header">
  <img [src]="logoUrl" alt="ID Verse Logo" />

  <h1 class="title">Verify your identity</h1>

  <span>
    We need to confirm your identity before providing you with your funds and
    the process takes only a few minutes. <br />
    Please complete your identity verification using your smartphone. Our secure
    verification system uses your mobile device and camera to ensure the highest
    level of safety. If you have any questions, don't hesitate to reach out to your Business
    Advisor.
  </span>
</header>
